export default __webpack_public_path__ + "86f5b3bc4d56de5e1caebe5ab4a1b26a.svg";